import FocusedLayout from './event-layout/FocusedLayout';
import { FOCUSED_BUILDERS_ENABLED } from './event-layout/focusedBuildersEnabled';
import React, { useEffect, useRef, useState } from 'react'
import { FaRulerHorizontal } from "@react-icons/all-files/fa/FaRulerHorizontal";
import { FaRulerVertical } from "@react-icons/all-files/fa/FaRulerVertical";
import { FaRuler } from "@react-icons/all-files/fa/FaRuler";
import PicCont from './PicCont';
import { geoProductsUpdateAvailability, getAllFilteredProducts, getProductsFilters, productsResetFilters } from '../store/slices/entities/products';
import { useSelector, useDispatch } from 'react-redux';
import { loadEntityForce } from '../store/slices/entities/crmActions';
import { showAlert, CLOSE_POPUP, SHOW_POPUP } from '../store/slices/ui';
import { helper } from '../utilities/helper';
import Button from './Button';
import { AiOutlineShoppingCart } from '@react-icons/all-files/ai/AiOutlineShoppingCart';
import { AiOutlineEdit } from '@react-icons/all-files/ai/AiOutlineEdit';
import { apiCallBegan } from '../store/api';
import { workingOrderReset, getWorkingOrder, workingOrderItemsReceived, workingOrderSetSettings } from '../store/slices/entities/orders';
import { cartAddItem, cartCleaned, getUser, getUserGeo } from '../store/slices/user';
import { getWorkingPackage, packageBuilderSet } from '../store/slices/entities/packages';
import { useRouter } from 'next/dist/client/router';
import { GiChoice } from "@react-icons/all-files/gi/GiChoice";
import { FaRulerCombined } from "@react-icons/all-files/fa/FaRulerCombined";
import * as gtag from '../lib/gtag'
import StageRender from './StageRender';
import { AiOutlineCloseCircle } from '@react-icons/all-files/ai/AiOutlineCloseCircle';
import lomomini from '../public/Pictures/lumol.png'
import { useOrderFlow } from './unified-order/OrderFlowProvider';
import { builderEquipmentPrice, builderFromConfiguration, createStageConfiguration, getAvailableStageSystems, getBuilderIndex, hydrateBuilderComponents } from '../utilities/builderConfiguration';
import styles from './BuilderExperience.module.scss';
import { resolveShoppingMarket } from '../utilities/fulfillmentMarket';
import RentalStartPopup from './design-system/commerce/RentalStartPopup';
import { ensureRentalBatchIdentity } from '../utilities/rentalDraftIdentity';

const projectDetailLabels = {
    use: {
        presentation: 'Presentation or ceremony',
        performance: 'Performance',
        concert: 'Concert or heavy equipment',
        runway: 'Runway'
    },
    environment: {
        indoor: 'Indoor',
        outdoor: 'Outdoor',
        unknown: 'Environment undecided'
    },
    surface: {
        level: 'Level hard surface',
        uneven: 'Grass or uneven surface',
        unknown: 'Surface undecided'
    }
}

const getProjectDetailsSummary = projectDetails => {
    const labels = [
        projectDetailLabels.use[projectDetails.use],
        projectDetailLabels.environment[projectDetails.environment],
        projectDetailLabels.surface[projectDetails.surface]
    ].filter(Boolean)

    return labels.length ? labels.join(' · ') : 'No optional event details selected'
}

const scrollBuilderElementIntoView = element => {
    if (!element || typeof window === 'undefined') return

    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    element.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
}

const StageBuilder = ({pre_height, pre_width, pre_length, pre_additions, pre_sel, pre_configuration, editingBuilderIndex }) => {
    let ref = useRef()
    const restoredSystem = useRef(false)
    const initialDimensions = pre_configuration?.dimensions
    let [length, setLength] = useState(() => initialDimensions?.length || pre_length ? Number(initialDimensions?.length || pre_length) : undefined)
    let { push, pathname } = useRouter()
    let [width, setWidth] = useState(() => initialDimensions?.width || pre_width ? Number(initialDimensions?.width || pre_width) : undefined)
    let [height, setHeight] = useState(() => initialDimensions?.height || pre_height ? Number(initialDimensions?.height || pre_height) : 24)
    let [additions, setAdditions] = useState(() => pre_configuration?.accessories ? {
        Skirt: pre_configuration.accessories.skirt || {},
        Steps: pre_configuration.accessories.steps || {},
        Railing: pre_configuration.accessories.railing || {},
        lights: Boolean(pre_configuration.accessories.lights)
    } : (pre_additions || {}))
    let [showAds, setShowAds] = useState()
    let [sel, setSel] = useState(() => pre_configuration?.system || pre_sel)
    let [setupOpen, setSetupOpen] = useState(() => !(pre_configuration?.system || pre_sel))
    let [projectDetails, setProjectDetails] = useState(pre_configuration?.projectDetails || {})
    const setupPanelRef = useRef(null)
    const resultHeadingRef = useRef(null)
    let products = useSelector(getAllFilteredProducts)
    let filters = useSelector(getProductsFilters)
    let dispatch = useDispatch()
    let { cart } = useSelector(getUser)
    let order = useSelector(getWorkingOrder)
    let pack = useSelector(getWorkingPackage)
    let geo = useSelector(getUserGeo)
    let shoppingMarket = resolveShoppingMarket({geo, order, pathname})
    let orlando = shoppingMarket === 'Orlando'
    let availableStageSystems = getAvailableStageSystems(shoppingMarket)
    let { launchIntent, unifiedEnabled } = useOrderFlow()
    let unifiedEligible = unifiedEnabled && !pack && !order?._id && !cart.items?.length

    useEffect(() => {
        if(sel && !availableStageSystems.includes(sel)) {
            setSel(availableStageSystems[0])
            setSetupOpen(true)
        }
    }, [availableStageSystems, sel])
    let intModule8 = products.find(p => p._id === "6671ae6d6243853a701e21b3")
    let intModule16 = products.find(p => p._id === "61e728deb3a6d00a20a9fb04")
    let intModule24 = products.find(p => p._id === "61e55f83161b731824bf2baf")
    let intSkirt8 = products.find(p => p._id === "663e738d6640d51061f7b857")
    let intSkirt16 = products.find(p => p._id === "663e78406f28f3072b3d25e6")
    let intSkirt24 = products.find(p => p._id === "6642425c1a14c8104d40951a")
    let intSkirt35 = products.find(p => p._id === "664243bca3f1e9107795f7a8")
    let intSkirt42 = products.find(p => p._id === "664249cd7db15e107fb031fd")
    let intRail = products.find(p => p._id === "61afc770cac29540b6f50fc9")
    let intSteps = products.find(p => p._id === "63c9ab20c7aad0097d2553a8")

    let msrLeg = products.find(p => p._id === "620baf6a291356870b02ba6b")
    let msrLong = products.find(p => p._id === "620bb053291356870b02c8c9")
    let msrShort = products.find(p => p._id === "620bb1d0291356870b02d701")
    let msrPlat = products.find(p => p._id === "620bab98291356870b02ac3a")
    let msrRailShort = products.find(p => p._id === "662910b1571fac7a09da7387")
    let msrRailLong = products.find(p => p._id === "6629105c571fac7a09da7349")
    let msrStairs = products.find(p => p._id === "620bf16b291356870b03a19c")

    let lumo16frame = products.find(p => p._id === "66511c6c9c1b871064e1b35d")
    let lumo8frame = products.find(p => p._id === "66510f6550d66210c9648063")
    let lumotop = products.find(p => p._id === "6650f4d3b2b45a10729c2c12")
    let lumo8side = products.find(p => p._id === "66510cbe379f4b103b2c8543")
    let lumo16side = products.find(p => p._id === "665120d877fcd1107442b7d2")
    let uplight = products.find(p => p._id === "66269650035d65c299579011")




    useEffect(() => {
        if (filters.static) {
            dispatch(loadEntityForce('products'))
            dispatch(productsResetFilters())
        }
    }, [filters.static, dispatch])

    useEffect(() => {
        gtag.event({ action: 'stage_builder_click', label: 'leads', value: 3, category: 'orders' })
    }, [])

    useEffect(() => {
        if (sel) gtag.event({ action: 'builder_step_view', label: `stage_dimensions_${sel}`, value: 0, category: 'orders' })
    }, [sel])

    useEffect(() => {
        if (FOCUSED_BUILDERS_ENABLED && restoredSystem.current) { restoredSystem.current = false; return }
        if(!pre_height && !pre_configuration) {
            if(sel !== 'lumo' && (width === 2 || length === 2)){
                    setLength(4)
                    setWidth(4)
                }else        if(!width) {
                    if (sel === 'msr' ) {
                        setLength(4)
                        setWidth(8)

                    } else {
                        setLength(4)
                        setWidth(4)
                    }
                } else if(sel === 'msr' && width %8 !==0) {
                    setWidth(8)
                }
                if(sel === 'lumo') {
                    setHeight('16')
                }
                if(sel === 'msr')     setHeight(27)
        }
    // Defaults apply only when the customer changes stage systems; dimensions remain user-controlled afterward.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sel])
    let stepsNum = Object.keys(additions.Steps || {}).filter(k => additions.Steps?.[k]).map(k => 1).reduce((a, b) => a + b, 0)
    let addToCartItems = async (delivery) => {
        if(order?.request_type === 'purchase' ) {
            if(!window.confirm(`This product is only available for rent, do you want to create a new rental order?`)) return
            else return   await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type, onSuccessFunc: () => cartCleaned() }))
        }
        if (delivery !== undefined || unifiedEligible || pack) {
            gtag.event({ action: 'stage_builder_done', label: 'leads', value: 15, category: 'orders' })
        }
        const existingIndices = (pack?.builders || []).map(getBuilderIndex).filter(Number.isFinite)
        const numId = Number.isFinite(Number(editingBuilderIndex)) ? Number(editingBuilderIndex) : Math.max(0, ...existingIndices) + 1
        const configuration = createStageConfiguration({
            system: sel,
            length,
            width,
            height,
            additions,
            branch: shoppingMarket,
            projectDetails
        })
        // The optional 3D choices stay dormant along with the focused preview.
        if (FOCUSED_BUILDERS_ENABLED) {
            if (sel === 'int' && pre_configuration?.accessories?.finish) configuration.accessories.finish = pre_configuration.accessories.finish
            if (sel === pre_configuration?.system && Number(height) === Number(pre_configuration?.dimensions?.height) && pre_configuration?.accessories?.stepType) configuration.accessories.stepType = pre_configuration.accessories.stepType
        }
        let _products = hydrateBuilderComponents(configuration, products)
        const resolved = await dispatch(apiCallBegan({
            url: '/inventory/pack/builder/resolve',
            method: 'POST',
            data: { configuration, index: numId },
            returnErrorData: true
        }))
        if (resolved?.errorMessage || resolved?.httpStatus || !resolved?.components?.length) {
            gtag.event({ action: 'builder_validation_error', label: resolved?.field || 'stage', value: 1, category: 'orders' })
            return dispatch(showAlert({ type: 'error', alert: resolved?.errorMessage || 'We could not verify this stage configuration. Your order was not changed. Please try again.' }))
        }
        _products = resolved.components
        const builder = {
            ...builderFromConfiguration({ configuration, index: numId, components: _products }),
            component_checksum: resolved?.component_checksum,
            pricing: { equipment_per_day: resolved?.equipment_per_day ?? builderEquipmentPrice(_products), generated_at: new Date().toISOString() }
        }
        if (delivery === undefined && !unifiedEligible && !pack) {
            const pickupAvailable = _products.every(component => component.product?.allow_pickup && !component.product?.requires_tech)
            const rentalData = ensureRentalBatchIdentity({ products: _products, builder, numId })
            const displayProduct = {
                _id: `configured-stage-${numId}`,
                name: `${width}′ × ${length}′ ${stageSystemName}`,
                picture: _products.find(component => component.product?.picture)?.product?.picture,
                price: { rental: builder.pricing.equipment_per_day },
                allow_pickup: pickupAvailable,
                requires_tech: !pickupAvailable,
                categories: ['staging/stage-rental']
            }
            dispatch(CLOSE_POPUP())
            return dispatch(SHOW_POPUP({
                key: 'stageRentalStart',
                size: 'xl',
                className: 'rentalStartShell',
                trapFocus: true,
                ariaLabelledBy: 'rental-start-title',
                body: <RentalStartPopup
                    product={displayProduct}
                    orlando={orlando}
                    pickupAvailableOverride={pickupAvailable}
                    rentalData={rentalData}
                    deliveryItems={_products}
                    builder={builder}
                    builderIndex={numId}
                    appendToExistingItems
                    onSelect={() => true}
                />
            }))
        }

        if (delivery === undefined && unifiedEligible && !pack) {
            const pickupAvailable = _products.every(component => component.product?.allow_pickup && !component.product?.requires_tech)
            const displayProduct = {
                _id: `configured-stage-${numId}`,
                name: `${width}′ × ${length}′ ${stageSystemName}`,
                picture: _products.find(component => component.product?.picture)?.product?.picture,
                price: { rental: builder.pricing.equipment_per_day },
                allow_pickup: pickupAvailable,
                requires_tech: !pickupAvailable,
                categories: ['staging/stage-rental']
            }
            dispatch(CLOSE_POPUP())
            return dispatch(SHOW_POPUP({
                key: 'stageRentalStart',
                size: 'xl',
                className: 'rentalStartShell',
                trapFocus: true,
                ariaLabelledBy: 'rental-start-title',
                body: <RentalStartPopup
                    product={displayProduct}
                    orlando={orlando}
                    pickupAvailableOverride={pickupAvailable}
                    selectionOnly
                    onSelect={async nextDelivery => {
                        dispatch(CLOSE_POPUP({ all: true }))
                        await launchIntent({
                            kind: 'configuration',
                            entityName: `${width}′ × ${length}′ stage`,
                            sourceSurface: 'stage_builder',
                            fulfillment: nextDelivery ? 'delivery_setup' : 'pickup',
                            components: _products.filter(component => component.product?._id && component.units > 0).map(component => ({
                                product: component.product._id,
                                units: component.units,
                                category: component.product.categories?.[0]?.split('/')?.[1]
                            }))
                        })
                        return false
                    }}
                />
            }))
        }
        if (unifiedEligible) {
            dispatch(CLOSE_POPUP())
            return launchIntent({
                kind: 'configuration',
                entityName: `${width}′ × ${length}′ stage`,
                sourceSurface: 'stage_builder',
                ...(delivery === undefined ? {} : { fulfillment: delivery ? 'delivery_setup' : 'pickup' }),
                components: _products.filter(component => component.product?._id && component.units > 0).map(component => ({
                    product: component.product._id,
                    units: component.units,
                    category: component.product.categories?.[0]?.split('/')?.[1]
                }))
            })
        }
        if (delivery && pack) {
            const previousBuilderIndex = Number.isFinite(Number(editingBuilderIndex)) ? Number(editingBuilderIndex) : undefined
            const previousComponents = Number.isFinite(previousBuilderIndex) ? (pack.components || []).filter(component => Number(component.builder_index) === previousBuilderIndex) : []
            previousComponents.forEach(component => dispatch(geoProductsUpdateAvailability({ product: component.product, units: component.units * -1 })))
            _products.forEach(component => dispatch(geoProductsUpdateAvailability(component)))
            dispatch(packageBuilderSet({ builder, components: _products, previousBuilderIndex }))
            dispatch(workingOrderItemsReceived([]))
            gtag.event({ action: 'builder_configuration_saved', label: Number.isFinite(previousBuilderIndex) ? 'stage_edit' : 'stage_new', value: 15, category: 'orders' })
            dispatch(CLOSE_POPUP())
            if (!pathname?.includes('planner')) {
                dispatch(workingOrderSetSettings({ step: 3, openSteps: 3 }))
                push(`/planner?id=${order._id}`)
            }

        } else if (delivery) {
            if (!cart.production && order._id && !pack) await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type }))
            dispatch(CLOSE_POPUP())
            dispatch(cartAddItem({ products: _products, delivery: true, builder, numId }))
        } else {
            // if (order?._id && units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included.some(ip => _products.find(produ => String(produ._id) == String(ip.product._id)).available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${product.name} has no more units available for the selected date` }))


            dispatch(CLOSE_POPUP())
            await dispatch(cartAddItem({ products: _products, builder, numId }))
        }


    }

    const rentalForAdditions = nextAdditions => builderEquipmentPrice(hydrateBuilderComponents(createStageConfiguration({ system: sel, length, width, height, additions: nextAdditions, branch: shoppingMarket, projectDetails }), products))
    const optionDeltaPrice = side => Math.abs(rentalForAdditions({ ...additions, [showAds]: { ...additions[showAds], [side]: !additions?.[showAds]?.[side] } }) - rentalForAdditions(additions))
    let SideAd = ({ side }) => <button type="button" aria-pressed={Boolean(additions[showAds]?.[side])} onClick={() => setAdditions(a => ({ ...a, [showAds]: { ...a[showAds], [side]: !a?.[showAds]?.[side] } }))} className={`${styles.sideChoice} ${additions[showAds]?.[side] ? styles.sideSelected : ''}`}>
        <span>{additions[showAds]?.[side] ? 'Remove' : 'Add'} {helper.tagUpper(side)} {showAds}</span>
        <strong>{additions[showAds]?.[side] ? '-' : '+'}{helper.formatPrice(optionDeltaPrice(side))}</strong>
    </button>

    let Addition = ({ image, name }) => <div className={`${styles.accessoryItem} ${(showAds === name) ? styles.accessoryOpen :(showAds && showAds !== name) ? styles.accessoryMuted : ''}`}>
        {showAds && showAds === name && name !== 'Up Lights' && <>
            <button type="button" className={styles.accessoryClose} aria-label={`Close ${name} side selector`} onClick={() => setShowAds(null)}><AiOutlineCloseCircle /></button>
            <SideAd side={'left'} />
            <SideAd side={'right'} />
            <SideAd side={'rear'} />
            {showAds !== 'Railing' && <SideAd side={'front'} />}

        </>}
        <button type="button" aria-pressed={name === 'Up Lights' ? Boolean(additions.lights) : showAds === name} className={`${styles.accessoryButton} ${name === 'Up Lights' && additions.lights ? styles.accessorySelected : ''}`} onClick={() => name === 'Up Lights' ?  setAdditions(a => ({ ...a, lights: !a.lights  }))  : setShowAds(name)}>
            <PicCont picture={image} />
            <span className="ct">{name === 'Up Lights' && additions.lights ? 'Remove' : 'Add'} {name}</span>
            { name === 'Up Lights' &&  <span className="ct"> {helper.formatPrice(((width /4)+ (length /4)) * uplight?.price?.rental)}</span>}
        </button></div>

    const previewConfiguration = sel && length && width ? createStageConfiguration({ system: sel, length, width, height, additions, branch: shoppingMarket, projectDetails }) : null
    const previewComponents = previewConfiguration ? hydrateBuilderComponents(previewConfiguration, products) : []
    const stageSystemName = sel === 'int' ? 'Light Stage' : sel === 'msr' ? 'Heavy Duty Stage' : 'LUMO Stage'
    const componentPrice = ids => previewComponents.filter(component => ids.includes(String(component.product?._id))).reduce((total, component) => total + ((component.product?.price?.rental || 0) * component.units), 0)
    const priceSkirts = componentPrice([intSkirt8?._id, intSkirt16?._id, intSkirt24?._id, intSkirt35?._id, intSkirt42?._id].filter(Boolean).map(String))
    const priceRailing = componentPrice([intRail?._id, msrRailShort?._id, msrRailLong?._id].filter(Boolean).map(String))
    const priceSteps = componentPrice([intSteps?._id, msrStairs?._id].filter(Boolean).map(String))
    const priceLights = componentPrice([uplight?._id].filter(Boolean).map(String))
    const totalRental = builderEquipmentPrice(previewComponents)
    const baseStagePrice = Math.max(0, totalRental - priceSkirts - priceRailing - priceSteps - priceLights)


    let estimatedDel = () => {
        if (sel === 'int') {
            let rows = length / 4
            let cols = width / 4
            let modules = rows * cols
            let del = (intModule24?.price.rental * ((intModule24?.difficulty / 10) + 0.25)) * modules
            del += (priceRailing + priceSkirts + priceSteps) * 0.45

            return del <240 ? 240 : del

        } else if (sel === 'msr') {
            let rows = length / 4
            let cols = width / 8

            let modules = rows * cols
            let del = (60 * ((4 / 10) + 0.25)) * modules
            del += (priceRailing + priceSkirts + priceSteps) * 0.45
            return del <240 ? 240 : del
        } else if (sel === 'lumo') {
            let rows = length / 2
            let cols = width / 2

            let modules = rows * cols
            let del = (60 * ((4 / 10) + 0.25)) * modules
            del += priceLights * 0.45
            return del <120 ? 120 : del
        }
    }

    const showResults = stageType => {
        setSel(stageType)
        setSetupOpen(false)

        window.requestAnimationFrame(() => {
            resultHeadingRef.current?.focus({ preventScroll: true })
            scrollBuilderElementIntoView(resultHeadingRef.current)
        })
    }

    const editSetupChoices = () => {
        setSetupOpen(true)

        window.requestAnimationFrame(() => {
            const firstControl = setupPanelRef.current?.querySelector('select, button')
            firstControl?.focus({ preventScroll: true })
            scrollBuilderElementIntoView(setupPanelRef.current)
        })
    }

    let HeadOption = ({ n, title, desc, price, pic, image }) => <button type="button" aria-pressed={sel === n} className={`${styles.stageOption} ${sel ? 'selMade' : ''} ${sel === n ? "optionCont sel" : "optionCont"}`} onClick={() => showResults(n)}>
        <PicCont width={300} height={300} picture={pic} src={image} alt="" />
        <div className={`col`}>
            <strong>{title}</strong>
            <p>{desc}</p>
            <span className='thick' >Price per Module: ${price}</span>
        </div>
    </button>

    let PriceRow =({price, name}) => {
        if(!price) return undefined
        else return <div className='addPrice'>
        <span className="addName"> <button type="button" className="builderEditLine" aria-label={`Edit ${name}`} onClick={() => {
          ref?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        })
            setShowAds(name)
        } }><AiOutlineEdit /></button> {name}</span>
        <strong className="addNum">
            {helper.formatPrice(price)}
        </strong>

    </div>
    }


    const recommendation = projectDetails.environment === 'outdoor' || projectDetails.surface === 'uneven' || projectDetails.use === 'concert'
        ? 'Heavy Duty Stage is recommended for this event.'
        : projectDetails.use === 'runway' || projectDetails.use === 'performance'
            ? 'Light Stage is a good starting point; Heavy Duty Stage is better for high loads.'
            : null
    const projectDetailsSummary = getProjectDetailsSummary(projectDetails)

    return <div className={`stageBuilder ${styles.root}`}>
        <header className={`builderIntro ${sel && !setupOpen ? styles.introCompact : ''}`}>
            <div>
                <span className="builderEyebrow">Custom stage builder</span>
                <h2 id="stage-builder-dialog-title">Build the right stage for your event</h2>
                <p>Choose the footprint, height and safety accessories. We will add every required system component to your setup.</p>
            </div>
            {Number.isFinite(Number(editingBuilderIndex)) && <span className="builderEditingBadge">Editing existing stage</span>}
        </header>

        {sel && !setupOpen && <div className={styles.setupSummary} aria-label="Selected stage setup">
            <div className={styles.summaryItem}>
                <span>Stage type</span>
                <strong>{stageSystemName}</strong>
            </div>
            <div className={styles.summaryItem}>
                <span>Event guidance</span>
                <strong>{projectDetailsSummary}</strong>
            </div>
            <button type="button" className={styles.editSetupButton} onClick={editSetupChoices} aria-expanded="false" aria-controls="stage-setup-choices">
                Edit setup choices
            </button>
        </div>}

        <div id="stage-setup-choices" ref={setupPanelRef} hidden={Boolean(sel && !setupOpen)}>
        <fieldset className="builderProjectDetails">
            <legend>Help us recommend the right stage <span>Optional</span></legend>
            <label>Primary use
                <select value={projectDetails.use || ''} onChange={event => setProjectDetails(details => ({ ...details, use: event.target.value }))}>
                    <option value="">Select use</option><option value="presentation">Presentation or ceremony</option><option value="performance">Performance</option><option value="concert">Concert or heavy equipment</option><option value="runway">Runway</option>
                </select>
            </label>
            <label>Environment
                <select value={projectDetails.environment || ''} onChange={event => setProjectDetails(details => ({ ...details, environment: event.target.value }))}>
                    <option value="">Select environment</option><option value="indoor">Indoor</option><option value="outdoor">Outdoor</option><option value="unknown">Not sure yet</option>
                </select>
            </label>
            <label>Surface
                <select value={projectDetails.surface || ''} onChange={event => setProjectDetails(details => ({ ...details, surface: event.target.value }))}>
                    <option value="">Select surface</option><option value="level">Level hard surface</option><option value="uneven">Grass or uneven surface</option><option value="unknown">Not sure yet</option>
                </select>
            </label>
            {recommendation && <p className="builderRecommendation" role="status">{recommendation}</p>}
        </fieldset>
        <h3 className={`stepTitle thick`}><GiChoice aria-hidden="true" />Step 1 · Choose stage type</h3>

        <div className={`selectRow ${sel ? 'noPad' : ''} `}>
      <HeadOption n={'int'} title={'Light Stage'} desc={`Light and easy to set stage recommended for indoor events. 4'x4' modules with height options of 16" and 24".`} pic={'myImage-1642539286662.jpg'} price={50} />

      <HeadOption n={'msr'} title={'Heavy Duty Stage'} desc={`Heavy duty option recommended for outdoor events and concerts. 8' × 4' modules with heights from 27 to 35 inches online.`} pic={'myImage-1644934299680.jpg'} price={"50-$72"} />

      {availableStageSystems.includes('lumo') && <HeadOption n={'lumo'} title={'LUMO Stage'} desc={`Semi-transparent acrylic stage. Great to be used with wash lights to create light effects. Modules are 2'x2'`} image={lomomini} price={"50-$75"} />}

        </div>
        </div>

        {sel && <>
            <h3 ref={resultHeadingRef} id="stage-results" tabIndex="-1" className={`stepTitle thick ${styles.resultHeading}`}><FaRulerCombined aria-hidden="true" />Step 2 · Stage dimensions & accessories</h3>
            <div className={styles.quickEstimate} aria-label="Current stage estimate">
                <div className={styles.estimatePrice}>
                    <span>Current equipment estimate</span>
                    <output aria-live="polite">{helper.formatPrice(totalRental)}</output>
                    <small>24-hour rental{!pack && ` · Estimated delivery and installation ${helper.formatPrice(estimatedDel())}`}</small>
                </div>
                <div className={`buttons ${styles.quickEstimateActions}`}>
                    {pack ?
                        <Button className='btn-4 highLight ' button_name={'add_product'} onClick={() => addToCartItems(true)}><AiOutlineShoppingCart /> {Number.isFinite(Number(editingBuilderIndex)) ? 'Save stage changes' : 'Add stage to setup'}</Button>
                        : <Button onClick={() => addToCartItems()} className='btn-4 highLight '><AiOutlineShoppingCart />Choose dates and rent online</Button>}
                </div>
            </div>
            <div className="axisRow">
                <div className="mainCol">
                    <div className={styles.previewHeading}>
                        <div>
                            <span>Live preview</span>
                            <strong>{width}′ × {length}′ stage</strong>
                        </div>
                        <small>{stageSystemName} · {height}″ high</small>
                    </div>
                    <FocusedLayout configuration={previewConfiguration} onRestoreConfiguration={saved => {
                        restoredSystem.current = saved.system !== sel
                        setSel(saved.system); setWidth(saved.dimensions.width); setLength(saved.dimensions.length); setHeight(saved.dimensions.height)
                        setAdditions({ Skirt: saved.accessories?.skirt || {}, Steps: saved.accessories?.steps || {}, Railing: saved.accessories?.railing || {}, lights: Boolean(saved.accessories?.lights) }); setProjectDetails(saved.projectDetails || {})
                    }}><StageRender height={height} stepsNum={stepsNum} rows={Math.ceil(length / (sel === 'lumo' ? 2 :4))} cols={Math.ceil(width / (sel === 'lumo' ? 2 :sel === 'msr' ? 8 : 4))} showAds={showAds} setAdditions={setAdditions} additions={additions} type={sel} /></FocusedLayout>

                    <div className={styles.accessoryHeading}>
                        <span>Accessories</span>
                        <small>Select an accessory, then choose the sides where it is needed.</small>
                    </div>
                    <div className={styles.accessoryGrid} ref={ref}>
                        {sel !== 'lumo' ? <>
                            <Addition name={'Skirt'} image={'myImage-1647615972681.jpg'} />
                            <Addition image={sel === 'msr' ? 'myImage-1715616990836.jpg' : 'myImage-1674160492815.jpg'} name={`Steps`} />
                            <Addition image={sel === 'msr' ? 'myImage-1713983281350.jpg' : 'myImage-1639416125417.jpg'} name={`Railing`} />
                        </> :
                            <Addition name={'Up Lights'} image={'myImage-1713805042417.jpg'} />
                        }
                    </div>
                </div>
                <div className="sideCol">
                    <div className={styles.panelHeading}>
                        <span>Configuration</span>
                        <p>Adjust the dimensions and review the price as you build.</p>
                    </div>
                    <div className='inputRow'>
                        <span className='meas'>Width:</span>
                        <div className={styles.control}>

                            <label htmlFor='stage-width' aria-label="Stage width"><FaRulerHorizontal /></label>

                            <select id='stage-width' aria-label="Stage width" value={width} onChange={e => {
                                if (sel === 'int' && ((length / 4) * (e.target.value / 4)) > 32) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible with the light stage, please try with our heavy duty line for large stages.' }))
                                if (sel === 'msr' && ((length / 8) * (e.target.value / 4)) > 42) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible, please try a smaller stage configuration.' }))
                                if (sel === 'lumo' && ((length / 2) * (e.target.value / 2)) > 50) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible, please try a smaller stage configuration.' }))
                                setWidth(e.target.value)
                            }} >
                                {sel === 'lumo' ? [2, 4, 6, 8, 10, 12, 14, 16, 18, 20,22, 24].map((l, i) => <option key={i} value={l}>{l} feet</option>) : sel === 'int' ? [4, 8, 12, 16, 20, 24, 28, 32, 36, 40].map((l, i) => <option key={i} value={l}>{l} feet</option>) : [8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96].map((l, i) => <option key={i} value={l}>{l} feet</option>)}

                            </select>
                        </div>
                    </div>
                    <div className='inputRow'>
                        <span className='meas'>Length:</span>
                        <div className={styles.control}>
                            <label htmlFor='stage-length' aria-label="Stage length"><FaRuler /></label>

                            <select id='stage-length' aria-label="Stage length" value={length} onChange={e => {
                                if (sel === 'int' && ((width / 4) * (e.target.value / 4)) > 32) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible with the light stage, please try with our heavy duty line for large stages.' }))
                                if (sel === 'msr' && ((width / 8) * (e.target.value / 4)) > 42) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible, please try a smaller stage configuration.' }))
                                    if (sel === 'lumo' && ((width / 2) * (e.target.value / 2)) > 50) return dispatch(showAlert({ type: 'error', alert: 'This configuration is not possible, please try a smaller stage configuration.' }))
                                    setLength(e.target.value)
                            }} >
                                {sel === 'lumo' ? [2, 4, 6, 8, 10, 12, 14, 16, 18, 20,22, 24].map((l, i) => <option key={i} value={l}>{l} feet</option>) : sel === 'int' ? [4, 8, 12, 16, 20, 24, 28, 32, 36, 40].map((l, i) => <option key={i} value={l}>{l} feet</option>) : [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 92, 96].map((l, i) => <option key={i} value={l}>{l} feet</option>)}
                            </select>

                        </div>
                    </div>
                    {sel === 'int' && <div className='inputRow'>    <span className='meas'>Height:</span>
                        <div className={styles.control}>
                            <label htmlFor='stage-height-int' aria-label="Stage height"><FaRulerVertical /></label>
                            <select id='stage-height-int' aria-label="Stage height" value={height} onChange={e => {

                                setHeight(e.target.value)
                            }} >
                                <option value={8}>9 inches</option>
                                <option value={16}>17 inches</option>
                                <option value={24}>25 inches</option>
                            </select>

                        </div>  </div>}
                    {sel === 'lumo' && <div className='inputRow'>    <span className='meas'>Height:</span>
                        <div className={styles.control}>
                            <label htmlFor='stage-height-lumo' aria-label="Stage height"><FaRulerVertical /></label>
                            <select id='stage-height-lumo' aria-label="Stage height" value={height} onChange={e => {

                                setHeight(e.target.value)
                            }} >
                                <option value={8}>8 inches</option>
                                <option value={16}>16 inches</option>

                            </select>

                        </div>  </div>}
                    {sel === 'msr' && <div className='inputRow'>    <span className='meas'>Height:</span>
                        <div className={styles.control}>
                            <label htmlFor='stage-height-msr' aria-label="Stage height"><FaRulerVertical /></label>
                            <select id='stage-height-msr' aria-label="Stage height" value={height} onChange={e => {

                                setHeight(e.target.value)
                            }} >
                                <option value={27}>27 inches</option>
                                <option value={35}>35 inches</option>

                            </select>

                        </div>  </div>}
                    <div className="priceCol">
                        <div className='addPrice'>
                            <span className="addName">Stage </span>
                            <strong className="addNum">
                                {helper.formatPrice(baseStagePrice)}
                            </strong>

                        </div>
                        <PriceRow name='Skirt' price={priceSkirts} />
                        <PriceRow name='Steps' price={priceSteps} />
                        <PriceRow name='Railing' price={priceRailing} />


                        <div className="finalPrice addPrice">
                            <span className="addName">Total Rental</span>
                            <strong className="addNum">
                                {helper.formatPrice(totalRental)}
                            </strong>
                        </div>
                    </div>

                    {!pack && <p className={styles.laborNote}>Final delivery and installation pricing is calculated after you provide the event dates and location.</p>}
                </div>

            </div>

        </>}


    </div>
}

export default StageBuilder
